/* 
 * Export container file to be used on project
*/

import ModalManager from './ModalManager.js';
export default ModalManager;
